module.exports = __webpack_public_path__ + "static/NGN-49e1682a2cd9fa8c91d83a0220e903ce.woff";